import { ThemeToggle } from "@/components/theme-toggle";

/** The account appearance choice: Light, Dark, or System. Saved on this device. */
export function AppearanceSection() {
  return (
    <div className="flex max-w-2xl flex-col gap-3">
      <section aria-label="Appearance" className="rounded-lg border p-4">
        <h2 className="text-base font-semibold">Theme</h2>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Light, dark, or follow this device. This choice is saved on this device only.
        </p>
        <div className="mt-3 max-w-xs">
          <ThemeToggle />
        </div>
      </section>
    </div>
  );
}
